<template>
  <!-- 版权声明 -->
  <div class="page-link-copyright" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
    <div class="page-link-copyright-wrap g-container g-wrap" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
      <div class="g-article-wrap mt-4 mt-md-4 px-4 px-md-0">
        <div class="header" v-if="breadType!=='1'">
          <h1>{{name}}</h1>
          <div class="line mt-5" v-if="!$vuetify.breakpoint.mobile">
            <img src="@images/line.png" alt="">
          </div>
        </div>

        <!-- 友情链接 -->
        <div class="friend-con" v-if="breadType==='1'">
          <div class="g-detail-title text-center">
            <img src="@images/title_youqinglianjie.png" alt="">
          </div>
          <div wrap class="card mt-8">
            <div class="card-item" xs12 sm12 md4 v-for="(item,index) in dataList" :key="index">
              <div class="g-border-box">
                <div class="g-border">
                  <span class="g-bor-dec g-bor-dec-1"></span>
                  <span class="g-bor-dec g-bor-dec-2"></span>
                  <span class="g-bor-dec g-bor-dec-3"></span>
                  <span class="g-bor-dec g-bor-dec-4"></span>

                  <p class="name-title py-1 px-3">{{item.label}}</p>
                  <div class="m-line my-4"></div>

                  <div class="name-list">
                    <p class="name" v-for="(it, i) in item.list" :key="i" @click="goLink(it)">{{it.title}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <v-layout wrap class="card mt-8">
            <v-flex class="card-item mb-5 pa-2" xs12 sm12 md4 v-for="index in 5">
              <div class="g-border-box">
                <div class="g-border">
                  <span class="g-bor-dec g-bor-dec-1"></span>
                  <span class="g-bor-dec g-bor-dec-2"></span>
                  <span class="g-bor-dec g-bor-dec-3"></span>
                  <span class="g-bor-dec g-bor-dec-4"></span>

                  <p class="name-title py-1 px-3">政府部门</p>
                  <div class="m-line my-4"></div>

                  <div class="name-list">
                    <p class="name" v-for="i in 10">中国政府网</p>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout> -->
        </div>

        <!-- 联系我们 -->
        <div class="g-detail-html trans my-5" v-html="$store.state.app.settingInfo.contactUs" v-if="breadType==='2'"></div>
        
        <!-- 版权声明 -->
        <div class="g-detail-html trans my-5" v-html="$store.state.app.settingInfo.remarks" v-if="breadType==='3'"></div>

        <!-- 隐私政策 -->
        <div class="g-detail-html trans my-5" v-html="$store.state.app.settingInfo.privacyPolicy" v-if="breadType==='4'"></div>

        <!-- <div class="g-detail-html my-5">
          <p>展览内容为图文混排，富文本编辑器，展览分为六个单元，集中展示了3000余件珍贵的贝类标本及贝文化相关文物，全方位展示了贝类背后蕴藏的文学、历史、医药、饮食、邮票等知识，是山东博物馆有史以来展出标本数量最多的自然类展览。展览内容为图文混排，富文本编辑器，展览分为六个单元，集中展示了3000余件珍贵的贝类标本及贝文化相关文物，全方位展示了贝类背后蕴藏的文学、历史、医药、饮食、邮票等知识，是山东博物馆有史以来展出标本数量最多的自然类展览。展览内容为图文混排，富文本编辑器，展览分为六个单元，集中展示了3000余件珍贵的贝类标本及贝文化相关文物，全方位展示了贝类背后蕴藏的文学、历史、医药、饮食、邮票等知识，是山东博物馆有史以来展出标本数量最多的自然类展览。</p>
          <img src="@images/1.jpg" alt="">
          <p>展览内容为图文混排，富文本编辑器，展览分为六个单元，集中展示了3000余件珍贵的贝类标本及贝文化相关文物，全方位展示了贝类背后蕴藏的文学、历史、医药、饮食、邮票等知识，是山东博物馆有史以来展出标本数量最多的自然类展览。展览内容为图文混排，富文本编辑器，展览分为六个单元，集中展示了3000余件珍贵的贝类标本及贝文化相关文物，全方位展示了贝类背后蕴藏的文学、历史、医药、饮食、邮票等知识，是山东博物馆有史以来展出标本数量最多的自然类展览。</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    watch: {
      $route(newVal) {
        this.breadType = this.$route.query.breadType
        this.name = this.$route.meta.breadType[this.$route.query.breadType].text
      }
    },
    data() {
      return {
        breadType: this.$route.query.breadType,  // 1 友情链接 2 联系我们  3 版权声明  4 隐私政策
        name: this.$route.meta.breadType[this.$route.query.breadType].text,
        dataList: []
      }
    },
    methods: {
      getDataList() {
        this.$http
          .get('/common/linkList', {})
          .then(res => {
            if (res.success) {
              this.dataList = res.data
            } else {
              this.$notify(res.message)
            }
          })
      },
      goLink(item) {
        window.open(item.outLinkUrl)
      }
    },
    created() {
      this.getDataList()
    }
  }
</script>

<style lang="scss" scoped>
.page-link-copyright-wrap {
  .friend-con {
    font-size: 16px;
    color: #292423;
    line-height: 34px;
    .name-title {
      width: 100%;
      font-size: 20px;
      color: #882d2a;
      background: url(~@images/bg_title.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .name-list {
      .name {
        cursor: pointer;
      }
    }
    .m-line {
      border-color: $primary;
    }
    .g-border-box {
      background: #faefe1;
      padding: 0;
      .g-border {
        border: solid 1px #D6A884;
        .g-bor-dec {
          background: url(~@images/border-1.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
  }

  // css实现瀑布流
  .card {
    width: 100%;
    columns: 3; // 默认列数
    column-gap: 30px; // 列间距
    .card-item {
      width: 100%;
      break-inside: avoid;
      margin-bottom: 30px;
    }
  }
}
</style>
